import React from 'react';

const pageLayout = props => {
  return (
    <div id="page-wrapper">
      <div className="row">
        <div className="col-lg-12 page-header">
        
        </div>
      </div>
      {props.children}
    </div>
  );
};

export default pageLayout;